import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { GpsCommand } from '@/types/gps';
import { toast } from 'sonner';

export function useGpsCommands(companyId?: string) {
  const queryClient = useQueryClient();

  // Fetch command history
  const { data: commands, isLoading } = useQuery({
    queryKey: ['gps-commands', companyId],
    queryFn: async (): Promise<GpsCommand[]> => {
      // TODO: Will be populated as commands are sent
      return [];
    },
    enabled: !!companyId,
    refetchInterval: 10000, // Refetch every 10 seconds
  });

  // Send command
  const sendCommand = useMutation({
    mutationFn: async (params: {
      device_id: string;
      command_type: string;
      payload?: Record<string, any>;
    }) => {
      if (!companyId) throw new Error('Company ID is required');

      const { data, error } = await supabase.functions.invoke('fleet-gps-send-command', {
        body: {
          company_id: companyId,
          device_id: params.device_id,
          command_type: params.command_type,
          payload: params.payload || {},
        },
      });

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gps-commands'] });
      toast.success('Comando enviado com sucesso');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Erro ao enviar comando');
      console.error('Error sending command:', error);
    },
  });

  // Get pending commands count
  const pendingCount = commands?.filter(cmd => cmd.status === 'pending').length || 0;

  return {
    commands,
    isLoading,
    sendCommand,
    pendingCount,
  };
}
